import i18n from "../../../plugins/locale/i18n";
import loadDictionary from "../../../plugins/locale/load-dictionary";
import { useEffect, useMemo, useRef, useState } from "react";
import BankAccountService from "../../../service/bank-account-service";
import Pasoonate from "pasoonate";
import ExcleJS from "exceljs";
import { saveAs } from "file-saver";

const bankAccountService = new BankAccountService();

await loadDictionary('bank-account-bon-card-receipts-page')

function BonCardReceiptsPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [receiptElements, setReceiptElements] = useState([]);
  const [filterFromDay, setFilterFromDay] = useState(0);
  const [filterFromMonth, setFilterFromMonth] = useState(0);
  const [filterFromYear, setFilterFromYear] = useState(0);
  const [filterToDay, setFilterToDay] = useState(0);
  const [filterToMonth, setFilterToMonth] = useState(0);
  const [filterToYear, setFilterToYear] = useState(0);
  const receipts = useRef([]);
  const timeoutRef = useRef(null);
  const referenceCode = useRef('');
  const monthOptions = useMemo(() => {
      const options = [];
      const monthList = Pasoonate.trans('jalali.month_name', 'fa');
      const currentMonth = Pasoonate.make().jalali().getMonth();
      
      for(let i in monthList) {
          options.push(<option key={i} value={i}>{monthList[i]}</option>);
      }

      setFilterFromMonth(currentMonth);
      setFilterToMonth(currentMonth);

      return options;
  }, []);
  const dayOptions = useMemo(() => {
      const options = [];
      const currentDay = Pasoonate.make().jalali().getDay();
      
      for(let i = 1; i <= 31; i++) {
          options.push(<option key={i} value={i}>{i}</option>);
      }

      setFilterFromDay(currentDay);
      setFilterToDay(currentDay);

      return options;
  }, []);


  const reloadList = (from, to) => {
    const fromDate = from || new Date();
    const toDate = to || new Date();

    receipts.current = [];
    setIsLoading(true);

    lazyLoad(fromDate, toDate);
  };

  const lazyLoad = (fromDate, toDate) => {
    bankAccountService.bonCardReceipts(fromDate, toDate, referenceCode.current).then((result) => {
      
      if(!result) { return; }

      receipts.current = receipts.current.concat(result.receipts);
      referenceCode.current = result.reference_code;

      let key = 1;
      const elements = receipts.current.map((receipt) =>
        <tr key={key++} >
          <td>{receipt.card_number}</td>
          <td><div dir="ltr" className="text-end">{Pasoonate.make().gregorian(receipt.datetime).jalali().format('yyyy/MM/dd HH:mm:ss')}</div></td>
          <td>{receipt.type}</td>
          <td><div dir="ltr" className="text-end">{Number(receipt.amount).toLocaleString()}</div></td>
          <td>{receipt.bank}</td>
          <td>{receipt.terminal_code}</td>
          <td>{receipt.reference_number}</td>
          <td>{receipt.sequence_number}</td>
          <td>{receipt.reserve_confirmation_code}</td>
          <td>{receipt.status}</td>
          <td>{i18n.t(`bank-account-bon-card-receipts-page.diff_levels.${receipt.diff_level}`)}</td>
        </tr>
      );
    
      setReceiptElements(elements);
      setCount(receipts.current.length);
      
      if(result.status === 'done') {
        setIsLoading(false);
        clearTimeout(timeoutRef.current);

        referenceCode.current = '';
        timeoutRef.current = null;
      } else {
        timeoutRef.current = setTimeout(() => { lazyLoad(fromDate, toDate) } , 5000);
      }
      
    }).catch((reason) => {
      console.log(reason);
      setIsLoading(false);
      clearTimeout(timeoutRef.current);

      referenceCode.current = '';
      timeoutRef.current = null;
    });
  };

  const filter = () => {
    const from = Pasoonate.make().jalali().setDateTime(filterFromYear, filterFromMonth, filterFromDay, 0, 0, 0).gregorian().getDateTime();
    const to = Pasoonate.make().jalali().setDateTime(filterToYear, filterToMonth, filterToDay, 23, 59, 59).gregorian().getDateTime();
    const fromDate = new Date(from.year, from.month - 1, from.day, from.hour, from.minute, from.second);
    const toDate = new Date(to.year, to.month - 1, to.day, to.hour, to.minute, to.second);

    reloadList(fromDate, toDate);
  };

  const downloadExcelFile = () => {
    const workbook = new ExcleJS.Workbook();

    workbook.creator = "Payment Service";
    workbook.created = new Date();

    const sheet = workbook.addWorksheet("sheet_1");
    sheet.views = [{rightToLeft: true}];

    const header = sheet.getRow(1);
    header.getCell(1).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.card_number");
    header.getCell(2).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.date");
    header.getCell(3).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.type");
    header.getCell(4).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.amount");
    header.getCell(5).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.terminal_name");
    header.getCell(6).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.terminal_code");
    header.getCell(7).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.reference_number");
    header.getCell(8).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.sequence_number");
    header.getCell(9).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.reserve_confirmation_code");
    header.getCell(10).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.status");
    header.getCell(11).value = i18n.t("bank-account-bon-card-receipts-page.table_columns.diff_level");

    receipts.current.forEach((item, index) => {
      const row = sheet.getRow(index + 2);

      row.getCell(1).value = item.card_number;
      row.getCell(2).value = Pasoonate.make().gregorian(item.datetime).jalali().format('yyyy/MM/dd HH:mm:ss');
      row.getCell(3).value = item.type;
      row.getCell(4).value = item.amount;
      row.getCell(5).value = item.bank;
      row.getCell(6).value = item.terminal_code;
      row.getCell(7).value = item.reference_number;
      row.getCell(8).value = item.sequence_number;
      row.getCell(9).value = item.reserve_confirmation_code;
      row.getCell(10).value = item.status;
      row.getCell(11).value = i18n.t(`bank-account-bon-card-receipts-page.diff_levels.${item.diff_level}`);

      row.getCell(4).numFmt = "#,###_);(#,###)";
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      saveAs(blob, "chek_diff_bon_card_receipts.xlsx");
    });
  };
  
  useEffect(() => {
    const currentYear = Pasoonate.make().jalali().getYear();

    setFilterFromYear(currentYear);
    setFilterToYear(currentYear);

    // reloadList();    
  }, []);

  return (
    <div className="page">
      <div className="page-header bg-body border-bottom p-3 pb-0">
        <div className="row mb-4">
          <div className="col">
            <h4 className="page-title">{i18n.t("bank-account-bon-card-receipts-page.page_title")}</h4>
          </div>
          {/* <div className="col-auto">
            <a className="link-secondary link-offset-1 link-underline-opacity-50" href="/bank-accounts">{i18n.t("bank-account-bon-card-receipts-page.bank_accounts_page_link")}</a>
          </div> */}
        </div>
        <div className="row mb-1">
          <div className="table-filter col-auto">
            <div className="row g-2">
              <div className="col-auto">
                <label className="form-label">از تاریخ</label>
                <div className="input-group mb-3">
                  <select className="form-select" value={filterFromDay} onChange={(e) => {setFilterFromDay(e.target.value)}}>
                    {dayOptions}
                  </select>
                  <select className="form-select" value={filterFromMonth} onChange={(e) => {setFilterFromMonth(e.target.value)}}>
                    {monthOptions}
                  </select>
                  <input type="text" dir="ltr" className="form-control" value={filterFromYear} placeholder="سال"  onChange={(e) => {setFilterFromYear(e.target.value)}}/>
                </div>
              </div>
              <div className="col-auto">
                <label className="form-label">تا تاریخ</label>
                <div className="input-group mb-3">
                  <select className="form-select" value={filterToDay} onChange={(e) => {setFilterToDay(e.target.value)}}>
                    {dayOptions}
                  </select>
                  <select className="form-select" value={filterToMonth} onChange={(e) => {setFilterToMonth(e.target.value)}}>
                    {monthOptions}
                  </select>
                  <input type="text" dir="ltr" className="form-control" value={filterToYear} placeholder="سال" onChange={(e) => {setFilterToYear(e.target.value)}}/>
                </div>
              </div>
              <div className="col-12 col-sm-auto">
                <label className="form-label d-none d-sm-inline-block">&nbsp;</label>
                <div className="d-grid mb-3">
                  <button type="submit" className={"btn btn-primary" + (isLoading ? " disabled" : "")} onClick={filter}>اعمال</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="my-1">{i18n.t("bank-account-bon-card-receipts-page.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'disabled' : '')} type="button" onClick={downloadExcelFile}><i className="bi bi-download"></i></button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.card_number")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.date")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.type")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.amount")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.terminal_name")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.terminal_code")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.reference_number")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.sequence_number")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.reserve_confirmation_code")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.status")}</th>
                <th>{i18n.t("bank-account-bon-card-receipts-page.table_columns.diff_level")}</th>
              </tr>
            </thead>
            <tbody>{receiptElements}</tbody>
          </table>
        </div>
      </div>
    </div>
  );

}

export default BonCardReceiptsPage;